import {ILlmToolUsedMessageTypeStrategyInterfaces} from '@toolify/server/src/services/MessageService/strategies/MessageTypeStrategies/LlmToolUsedMessageTypeStrategy/types/ILlmToolUsedMessageTypeStrategyInterfaces'

function toLlmToolName(text: string): string {
  return text
    .replace(/[^a-zA-Z0-9_-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .toLowerCase()
}

export function isLlmToolFallbackActionText(toolName: string, actionText: string | null | undefined): boolean {
  const trimmedActionText = actionText?.trim()
  return !trimmedActionText || toLlmToolName(trimmedActionText) === toolName
}

export function getLlmToolUsedLabel(
  payload: ILlmToolUsedMessageTypeStrategyInterfaces['payload'],
  toolTitle: string | null = null,
): string {
  const actionText = payload.actionText?.trim() || null
  if (actionText && !isLlmToolFallbackActionText(payload.toolName, actionText)) {
    return actionText
  }
  return toolTitle || actionText || payload.toolName
}
